
import './index.less'
import React from 'react'
console.log(React)
export default function ConversionOfficial(props) {
  return (<div className={`conversionOfficial ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}
  >
    <button className='conversionOfficial_button' style={{
      backgroundColor: props.ifon.bg_color,
      color: props.ifon.font_color,
      marginTop: props.ifon.padding_top + 'px',
      marginBottom: props.ifon.padding_bottom + 'px',
      fontWeight: props.ifon.text_alignment ? 'bold' : 'normal',
      border: `2px solid ${props.ifon.border_color}`
    }}>{props.ifon.isIcon && <i className='icon'>
        <svg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M6.52659 10.2918C5.91359 9.56524 5.41666 8.20791 5.41666 7.25774V5.83298C5.41666 3.99223 6.91279 2.5 8.74999 2.5C10.5909 2.5 12.0833 3.99415 12.0833 5.83351V7.25849C12.0833 8.20775 11.5841 9.56905 10.9734 10.293L10.6721 10.6501C10.1809 11.2325 10.3343 11.9737 11.0213 12.3088L15.7382 14.6096C16.251 14.8597 16.6667 15.521 16.6667 16.0962V16.668C16.6667 17.1275 16.2909 17.5 15.8321 17.5H1.66785C1.20696 17.5 0.833328 17.1298 0.833328 16.668V16.0962C0.833328 15.5253 1.24845 14.8599 1.76174 14.6094L6.4787 12.3076C7.16281 11.9738 7.32188 11.2344 6.82787 10.6489L6.52659 10.2918ZM16.875 8.95833H19.1667V10.2083H16.875V12.5H15.625V10.2083H13.3333V9.58333V8.95833H15.625V6.66667H16.875V8.95833Z'></path></svg>
      </i>}<span>{props.ifon.title}</span></button>
  </div>)
}
